import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=d9d013c2&scoped=true&"
import script from "./CopyIcon.vue?vue&type=script&lang=js&"
export * from "./CopyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CopyIcon.vue?vue&type=style&index=0&id=d9d013c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d013c2",
  null
  
)

export default component.exports